import { render } from "./GalleryFilterSliderInput.vue?vue&type=template&id=1871a3d0"
import script from "./GalleryFilterSliderInput.vue?vue&type=script&lang=js"
export * from "./GalleryFilterSliderInput.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__